import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class LaborManagement_ds_assigned_task_operation_codes_flow_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { warehouseIds?: number[], workClassIds?: number[], ownerId?: number, projectId?: number, fromDate?: string, toDate?: string, fullTextSearch?: string, $top?: number, $skip?: number }): Promise<{ result?: { operationCodeName?: string, operationCodeId?: number }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/LaborManagement/datasources/ds_assigned_task_operation_codes_flow_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouseIds?: number[], workClassIds?: number[], ownerId?: number, projectId?: number, fromDate?: string, toDate?: string, fullTextSearch?: string, $keys: number[] }): Promise<{ result?: { operationCodeName?: string, operationCodeId?: number }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LaborManagement/datasources/ds_assigned_task_operation_codes_flow_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      warehouseIds?: number[], workClassIds?: number[], ownerId?: number, projectId?: number, fromDate?: string, toDate?: string, fullTextSearch?: string    }) {
      return false;
    }
}
